import {DateTime} from 'luxon';

export interface MonthObj {
  key: string;
  name: string;
}

export const getMonths = () => {
  const monthArray: MonthObj[] = [];

  for (let i = 0; i < 12; i++) {
    const month = DateTime.now().minus({months: i});
    monthArray.push({
      key: month.toFormat('MM'),
      name: `${month.monthLong} ${month.year}`,
    });
  }
  return monthArray;
};
